import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-info-corporativa',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './info-corporativa.component.html',
  styleUrls: ['./info-corporativa.component.scss']
})
export class InfoCorporativaComponent {

}
